/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * 見えるボタンの形。SQUARE=角 / ROUNDED=角丸 / PILL=丸型
 */
export type HotspotButtonShape = (typeof HotspotButtonShape)[keyof typeof HotspotButtonShape]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotspotButtonShape = {
  SQUARE: 'SQUARE',
  ROUNDED: 'ROUNDED',
  PILL: 'PILL',
} as const
